
import { useState,useEffect } from 'react'
import './styles/NotifiAdmin.css'
import Action from '../Action'
import { useFetch } from '../../hooks/useFetch'
import Selector from '../Selector'
import LoadSimple from '../LoadSimple'
import {roles}  from '../generales/GroupsId';
import Search from '../generales/Search'
import { lang } from '../generales/traduction'
import { capitalizeFirstLetter } from '../../utils/utils'
import Paginador from '../generales/Paginador'

const NotifiAdmin=({languaje,mode,server,setInternalError})=>{
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [editActive, setEditActive] = useState(false);
  const [nivelForm,setNivelForm]=useState(1)
  const [userData,setUserData]=useState({name:"",description:"",permissions:""})
  const [disabled,setDisabled]=useState(true)
  const [permisos,setPermisos]=useState([])
  const [loading,setLoading]=useState(false)
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [rolSelected,setRolSelected]=useState(0)
  const [checkboxes, setCheckboxes] = useState({
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      checkbox5: false,
    });
  const [infoPermission,setInfoPermission]=useState('')
  const [dataPermisos,setDataPermisos]=useState({data:[],loading:true,error:''})
  const [dataRoles,setDataRoles]=useState({data:[],loading:true,error:''})
  const [dataReports,setDataReports]=useState({data:[],loading:true,error:''})
  const [RolData,setRolData]=useState({data:[],loading:true,error:''})
  const limitList = 200;
  const [pageActual, setPageActual] = useState(1);
  const startLimit = limitList * pageActual - limitList;
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? (dataRoles.data.length==0?[]:dataRoles.data.data) : searchResults;
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const pages = parseInt(dataList.length / limitList) + 1;
  const addPermiso=(e)=>{
    if (permisos.includes(e)) {
        // Eliminar el valor si ya existe
        const nuevoArreglo = permisos.filter(valor => valor !== e);
        setPermisos(nuevoArreglo);
      } else {
        // Agregar el valor si no existe
        const nuevoArreglo = [...permisos, e];
        setPermisos(nuevoArreglo);
      }
    // const nuevoArreglo = [...permisos, e]
  }

  useEffect(()=>{
    if(permisos.length!==0  && userData.name!==""){
        setDisabled(false)
    }else{
        setDisabled(true)
    }
    setUserData((prevState)=>{
        return {
            ...prevState,
            ['permissions']:permisos.join(',')
        }
        
    })
  },[permisos])
  useEffect(()=>{
    if(editActive){}
    
},[RolData.data])
  const handleChange=(e)=>{
    const {name,value}=e.target
    setUserData((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
    if(permisos.length!==0  && value!==""){
        setDisabled(false)
    }else{
        setDisabled(true)
    }
  }
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [selectedCheckboxes2, setSelectedCheckboxes2] = useState([]);
  const [idUsers,setIdUsers]=useState([])
  const getRoles=()=>{
    setDataRoles({data:dataRoles.data,loading:true,error:''})
    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/reports/notifications/user_reports', {
       method: 'GET',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
     });

     if (response.ok) {
       const data1 = await response.json();
       setIdUsers(data1.data.map(obj => obj.user_id))
       setDataRoles({data:data1,loading:false,error:''})
       setSelectedCheckboxes(data1.data.filter(obj => obj["1"] === 1).map(obj => obj.user_id))
       setSelectedCheckboxes2(data1.data.filter(obj => obj["6"] === 1).map(obj => obj.user_id))
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        setInternalError(true)
          setDataRoles({data:dataRoles.data,loading:false,error:''})
        console.error(error);
      }
    };

    fetchDataPost();
  }

  const getReportesInfo=()=>{
    setDataReports({data:dataReports.data,loading:true,error:''})
    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/reports/notifications/report_names', {
       method: 'GET',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
     });

     if (response.ok) {
       const data1 = await response.json();

       setDataReports({data:data1,loading:false,error:''})
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        setInternalError(true)
        setDataReports({data:dataReports.data,loading:false,error:''})
        console.error(error);
      }
    };

    fetchDataPost();
  }
  useEffect(()=>{
    setInternalError(false)
    getReportesInfo()
    getRoles()
  },[])


  const handleSelectAll = (event) => {
    if (event.target.checked ) {
      const allCheckboxes = dataRoles.data.data.map((element) => element.user_id);
      setSelectedCheckboxes(allCheckboxes);
    } else {
      setSelectedCheckboxes([]);
    }
  };
  const handleSelectAll2 = (event) => {
    if (event.target.checked ) {
      const allCheckboxes = dataRoles.data.data.map((element) => element.user_id);
      setSelectedCheckboxes2(allCheckboxes);
    } else {
      setSelectedCheckboxes2([]);
    }
  };
  // Maneja la selección individual de cada checkbox
  const handleCheckboxChange = (rol_id) => {
    setSelectedCheckboxes((prevSelected) =>
      prevSelected.includes(rol_id)
        ? prevSelected.filter((id) => id !== rol_id)
        : [...prevSelected, rol_id]
    );
  };
  const handleCheckboxChange2 = (rol_id) => {
    setSelectedCheckboxes2((prevSelected) =>
      prevSelected.includes(rol_id)
        ? prevSelected.filter((id) => id !== rol_id)
        : [...prevSelected, rol_id]
    );
  };
  const [arraySave,setArraySet]=useState({users_ids:[],cassia_report_frequency_schedule_ids:[]})
  const guardar=()=>{
    const cassia_report_frequency_schedule_ids = idUsers.map(user_id => {
      const isSelectedCheckbox1 = selectedCheckboxes.includes(user_id);
      const isSelectedCheckbox2 = selectedCheckboxes2.includes(user_id);
    
      if (isSelectedCheckbox1 && isSelectedCheckbox2) {
        return [1, 6];
      } else if (isSelectedCheckbox1) {
        return [1];
      } else if (isSelectedCheckbox2) {
        return [6];
      } else {
        return [];
      }
    });
    const  result = {
      user_ids: idUsers,
      cassia_report_frequency_schedule_ids:cassia_report_frequency_schedule_ids
      // cassia_report_frequency_schedule_ids: idUsers.map(user_id => (selectedCheckboxes.includes(user_id) ? [1] : []))
    }
    let method='POST'

    setDataRoles({data:dataRoles.data,loading:true,error:''})

    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/reports/notifications/user_reports', {
       method: method,  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
       body: JSON.stringify(result),
     });
     if (response.ok) {
       const data1 = await response.json();
       // setLoading(false)
       // setUserData({name:"",description:"",permissions:""})
       // setPermisos([])

       getRoles()

       setDataRoles({data:dataRoles.data,loading:false,error:''})
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        setInternalError(true)
          // setUserData({name:"",description:"",permissions:""})
          // setPermisos([])
          // setDataPermisos({data:dataPermisos.data,loading:false,error:''})
  setLoading(false)
        console.error(error);
      }
    };

    fetchDataPost();
  }
  const {name,description,permissions}=userData
  return (
    <>
    <div className='head-cis'>
    <div className='title-cis'>
                <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    // onSearch={handleSearch}
                    dataObject={dataRoles.data.data}
                    setDataObject={setDataUsers}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  />
          <div className={"cont-result-registers"+mode}>
         
                  <p style={{  textAlign: "center" }}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      dataList.length +
                      ") " 
                      }
                  </p> 
          </div>
          <div className="cont-buttons-panel">
                  
                    <Action
                    disabled={false}
                    origen="Azul"
                    titulo={""+capitalizeFirstLetter(lang[languaje]['guardar'])}
                    action={guardar}
                  />
                  
                 
                </div>
                </div>
                
            </div>
            <div className='cont-cis'>
            <>
      <div className="main-panel-cis">
      <div className="compact-content-portafolio">
      <div className={"content-portafolio-head"+mode}>
              
              
              </div>
        <div className="content-portafolio">
          

          <div className="cont-portafolio-table">
            <div className="content-card-portafolio" id="content">
              {/*  aqui inicia */}
<>


                              <div className='cont-table-portafolio cont-table-roles ' >
                                  <div className={"head-table-portafolio"+mode}>
                                      {/* <div className='field-head-table-users field-acciones'>
                                          Acciones
                                      </div> */}
                                      <div className="compact-head-table-portafolio">
                                      <div className='field-head-table-users field-nombre' style={{width:'30%'}}>
                                          {capitalizeFirstLetter(lang[languaje]['usuarios'])}
                                      </div>
                                     
                                      {(dataReports.loading)?'':
                                      dataReports.data.data.map((element,index)=>(
                                        <div className='field-head-table-users field-nombre' style={{width:'15%'}}>
                                        <div className='headNotifiAdmi '>
                                        <div class="tooltiptextNotifi" >{element.description}</div>
                                        {element.name}
                                        </div>
                                        <div className='contCheckNotifiAdmi'>
                                            <div className='title' style={{fontSize:'var(--font-size-xSmall)'}}>
                                                {lang[languaje]['todos'].toUpperCase()}
                                            </div>
                                            <div className='input'>
                                            {
                                               (dataRoles.loading)?<></>:(element.cassia_report_frequency_schedule_id==1)?
                                                <input type='checkbox' className='NotifiCheckBox' style={{width: '100%',
                                                  height: '100%',
                                                  top: '50%',
                                                  position: 'relative'}} onClick={handleSelectAll} checked={selectedCheckboxes.length === dataRoles.data.data.length}></input>:
                                                <input type='checkbox' className='NotifiCheckBox' onClick={handleSelectAll2} checked={selectedCheckboxes2.length === dataRoles.data.data.length} style={{width: '100%',
                                                  height: '100%',
                                                  top: '50%',
                                                  position: 'relative'}}></input>
                                              }
                                            </div>
                                       
                                        </div>
                                    </div>))
                                      }
                                       </div>
                                      

                                  </div>
                                  <div className='body-table-portafolio'>
                                  <div className='cont-row-user-list'>
                                  { (dataRoles.loading)?<div style={{width:'100%',height:'95%',display:'flex',justifyContent:'center'}}><LoadSimple></LoadSimple></div>:
                                              // dataRoles.data.data.map((element,index)=>(
                                                dataList.map((element,index)=>(
                                                  <div className={"row-table-portafolio"+mode} key={index} >
                                                  <div className='field-body-table-users field-nombre' style={{width:'30%'}}>
                                                    {element.name}
                                                  </div>
                                                  
                                          <div className='field-body-table-users field-correo' style={{width:'15%',fontWeight:'bold'}}>
                                                 <input    type='checkbox' className='NotifiCheckBox noti1' checked={selectedCheckboxes.includes(element.user_id)} defaultChecked={true} 
                onChange={() => handleCheckboxChange(element.user_id)}></input>
                                                  </div>
                                                  <div className='field-body-table-users field-correo' style={{width:'15%',fontWeight:'bold'}}>
                                                 <input    type='checkbox' className='NotifiCheckBox noti1' checked={selectedCheckboxes2.includes(element.user_id)} defaultChecked={true} 
                onChange={() => handleCheckboxChange2(element.user_id)}></input>
                                                  </div>
                                                  
                                                </div>   
                                          ))}
      
          
         
      
      
                                    </div>
                               
                                  </div>
                              </div>
                                 
</>

     {/*  aqui termina */}         
            </div>
          </div>
        </div>
        <div className={"content-portafolio-footer"+mode}>
          <div className="cont-display-paginador">
                    <Paginador  pages={pages}
                                pageActual={pageActual}
                                setPageActual={setPageActual}
                                mode={mode}></Paginador>
          </div>
          <div className="cont-display-paginador">
            <div className={"cont-half-display-paginador"+mode}>
                      
                  
            </div>
            <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                          ?  parseInt(pageActual ) * parseInt(limitList)
                          : dataList.length) +
                        ")  "+lang[languaje]['de']+" " +
                        dataList.length +
                        " "+lang[languaje]['resultados']}
                      </p>
                  
            </div>
          </div>  
                    
        </div>
        </div>

      </div>
      
    </>
                
            </div>
    </>
  )
}

export default NotifiAdmin